
import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/deposit/cashapp_merchant';
import {clearCashappMerchantOrder} from '../../../../reducers/app/actions';
import {useLocation} from 'react-router-dom';

import Enter from './enter';
import Alert from './alert';

export default ({setMethod}) => {
    const {order, button} = useSelector(Selector),
          location = useLocation(),
          dispatch = useDispatch();

    useLocation(() => {
        return () => dispatch(clearCashappMerchantOrder());
    }, [location]);

    if(!order)
        return <Enter setMethod={setMethod} button={button} />

    return <Alert order={order} />
}